import React, { useState, useEffect, useContext } from "react";
import { Card, Row, Col, Spin, Carousel, Button } from "antd";
import { PublicContext } from "../PublicContext";
import { useNavigate } from "react-router-dom";
import "../../styles/custom.css";

const { Meta } = Card;

export default function PromoCarousel() {
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const { promotions } = useContext(PublicContext);

    const [menuItem, setMenuItem] = useState({
        productName: "",
        price: 0,
        description: "",
        pictureURL: "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png",
    });

    const contentStyle = {
        height: "160px",
        color: "black",
        marginBottom: 0,
        lineHeight: "160px",
        textAlign: "center",
        // background: "#364d79",
    };

    const navigate = useNavigate();

    const formatDate = (dateString) => {
        // Parse the date string into a Date object
        const dateObject = new Date(dateString);

        // Check if the dateObject is a valid Date
        if (isNaN(dateObject.getTime())) {
            return "Invalid Date";
        }

        // Specify formatting options
        const options = { month: "long", day: "2-digit" };

        // Use toLocaleDateString to format the date
        const formattedDate = dateObject.toLocaleDateString(undefined, options);

        return formattedDate;
    };

    useEffect(() => {
        if (promotions != null) {
            setLoading(false);
        }
    }, [promotions]);

    function choosePickUp() {
        console.log("pickup");
        sessionStorage.setItem("deliveryOrPickUp", "pickup");
        navigate(`/locationsmap`);
    }

    function chooseDelivery() {
        console.log("delivery");
        sessionStorage.setItem("deliveryOrPickUp", "delivery");
        navigate(`/locationsmap`);
    }

    function renderProductsTable(products) {
        return (
            <Carousel autoplay>
                {promotions.map((promotion) => {
                    return (
                        <div
                            key={promotion.id}
                            className="carousel-item"
                        >
                            <img
                                alt={promotion.promotionName}
                                src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/promotion/` + promotion.promotionPicture}
                                style={{ width: "100%" }}
                                onError={(e) => {
                                    e.target.src = "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png";
                                    e.target.onerror = null;
                                }}
                            />
                            <div className="promo-carousel-overlay-text">
                                <Button className="btn-primary pickup-delivery-button pickup-delivery-button-overlay" shape="round"
                                    onClick={() => chooseDelivery()}
                                >
                                    Delivery
                                </Button>

                                <Button
                                    className="btn-secondary pickup-delivery-button pickup-delivery-button-overlay" shape="round"
                                    onClick={() => choosePickUp()}
                                >
                                    Pick Up
                                </Button>
                            </div>
                        </div>
                    );
                })}
            </Carousel>
        );
    }

    function renderLoading() {
        return <Spin />;
    }

    return (
        <div>
            {loading ? renderLoading() : renderProductsTable(products)}
        </div>
    );
}
